import LikeIcon from "@/components/Like/LikeIcon";
import DynamicAvatar from "@/components/MyAvatar/DynamicAvatar";
import { useMetaLikeAndComment } from "@/hooks/useMeta";
import useTranslation from "@/hooks/useTranslation";
import { ICollection } from "@/interfaces/bundle.interface";
import { modifyAvatarUrl } from "@/utils/avatar.util";
import { totalSanitize } from "@/utils/sanitize.util";
import { shortUUID } from "@/utils/string.util";
import { formatRelativeTime } from "@/utils/time.util";
import { IconButton } from "@material-ui/core";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import TextsmsOutlinedIcon from "@material-ui/icons/TextsmsOutlined";
import { Card, Tooltip, Typography } from "antd";
import Link from "next/link";
import React from "react";
import styles from "./styles.module.less";

const { Paragraph } = Typography;

interface IProps {
  collection: ICollection;
  loading: boolean;
}

const CollectionCard: React.FC<IProps> = ({ collection, loading }) => {
  const { t } = useTranslation("bundle");
  const { commentTimeCount } = useMetaLikeAndComment(collection.id);
  return (
    <Card loading={loading} className={styles.container}>
      <Card.Meta
        avatar={
          <Tooltip title={collection.owner.username}>
            <DynamicAvatar
              src={modifyAvatarUrl(collection.owner.avatarUrl)}
              size="large"
            />
          </Tooltip>
        }
        title={
          <Link
            href="/bundle/collection/[id]"
            as={`/bundle/collection/${shortUUID(collection.id)}`}
          >
            <a className={styles.href}>{collection.name}</a>
          </Link>
        }
        description={
          <>
            {collection.description && (
              <Paragraph ellipsis={{ rows: 1, expandable: true }}>
                {totalSanitize(collection.description)}
              </Paragraph>
            )}
            <div className={styles.flexCenter}>
              <IconButton>
                <DescriptionOutlinedIcon />
                <span className={styles.iconText}>
                  {collection?.paperIds?.length}
                </span>
              </IconButton>
              <LikeIcon
                fatherId={collection?.id}
                init={true}
                url={`/bundle/collection/${shortUUID(collection?.id)}`}
              />
              <IconButton>
                <TextsmsOutlinedIcon />
                <span className={styles.iconText}>{commentTimeCount}</span>
              </IconButton>
              <div className={styles.time}>
                {formatRelativeTime(collection.updated_at)}
              </div>
            </div>
          </>
        }
      />
    </Card>
  );
};

export default CollectionCard;
